import { DomainPreferences } from '../../../../api/types';
import { DashboardConfig } from '../../../../common/components/dashboards/types';
import { Languages } from '../../../../constants';
import { StoryboardDateUtils } from '../../utils';
import { getNikkiHeadcountDbPageConfigs } from './nikki-headcount-db-page-configs';

const dashboardId = 'global_hr_headcount';
export const NikkiHeadcountDashboardConfig: (domainPreferences: DomainPreferences) => DashboardConfig = (
  domainPreferences: DomainPreferences
) => {
  const storyboardDateUtils = new StoryboardDateUtils();
  return {
    id: dashboardId,
    title: {
      [Languages.EN]: 'Global HR Headcount',
      [Languages.JA]: 'Global HR Headcount',
    },
    enabled: true,
    pages: getNikkiHeadcountDbPageConfigs(dashboardId, storyboardDateUtils),
  };
};
